module.exports = __webpack_public_path__ + "static/media/vehicles-all-2.c5bf6dbb.svg";